import DefectGroups from 'src/views/Pages/Dashboard/Quality/BoxInspection/DefectGroups/DefectGroups.vue';
import DefectGroupsCreateEdit from 'src/views/Pages/Dashboard/Quality/BoxInspection/DefectGroups/EditCreate.vue';
import DefectsCategories from './DefectsCategories/DefectsCategories.vue';
import DefectsCategoriesCreateEdit from './DefectsCategories/DefectsCategoriesCreateEdit.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import LocationInspection from 'src/views/Pages/Dashboard/Quality/BoxInspection/LocationInspection/LocationInspection.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import Quality from './Master/Quality.vue';
import QualityCreateEdit from './Master/QualityCreateEdit.vue';
import QualityPercentage from 'src/views/Pages/Dashboard/Quality/BoxInspection/QualityPercentage/QualityPercentage.vue';
import ReportQuality from './Report/Reports.vue';
import SamplingReport from './SamplingReport/SamplingReport.vue';
import BoxInspection from './BoxInspection/Master/BoxInspections.vue';
import EditCreate from 'src/views/Pages/Dashboard/Quality/BoxInspection/Master/EditCreate.vue';
import PCMSReport from './PCMSReport/PCMSReport.vue';

const QualityRoutes = {
  path: 'quality',
  name: 'Calidad',
  component: MasterTab,
  props: { reference: 'qualityTabs' },
  children: [
    {
      path: 'inspections',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Calidad',
          component: ReportQuality,
          meta: {
            prefix_permission: 'quality_inspections',
          },
        },
      ],
    },
    {
      path: 'samplingreport',
      name: 'Calidad',
      component: SamplingReport,
      meta: {
        prefix_permission: 'quality_samplingreport',
      },
    },
    {
      path: 'quality',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Calidad',
          component: Quality,
          meta: {
            prefix_permission: 'quality_quality',
          },
        },
        {
          path: 'create',
          name: 'Calidad',
          component: QualityCreateEdit,
          meta: {
            prefix_permission: 'quality_quality',
          },
        },
        {
          path: 'edit',
          name: 'Calidad',
          component: QualityCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'quality_quality',
          },
        },
      ],
    },
    {
      path: 'captures',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Calidad',
          component: () =>
            import('src/views/Pages/Dashboard/Quality/Quality/Capture.vue'),
          meta: {
            prefix_permission: 'quality_inspections',
          },
        },
      ],
    },
    {
      path: 'defectscategories',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Calidad',
          component: DefectsCategories,
          meta: {
            prefix_permission: 'quality_Defectscategories',
          },
        },
        {
          path: 'create',
          name: 'Calidad',
          component: DefectsCategoriesCreateEdit,
          meta: {
            prefix_permission: 'quality_DefectsCategoriesCreateEdit',
          },
        },
        {
          path: 'edit',
          name: 'Calidad',
          component: DefectsCategoriesCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'quality_DefectsCategoriesCreateEdit',
          },
        },
      ],
    },
    {
      path: 'qualitypercentages',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'boxinspection.quality_percentages',
          component: QualityPercentage,
          meta: {
            prefix_permission: 'quality_qualitypercentages',
          },
        },
      ],
    },
    {
      path: 'locationinspections',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'boxinspection.inspection_locations',
          component: LocationInspection,
          meta: {
            prefix_permission: 'quality_locationinspections',
          },
        },
      ],
    },
    {
      path: 'defectgroups',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'boxinspection.quality_categories_defects',
          component: DefectGroups,
          meta: {
            prefix_permission: 'quality_defectgroups',
          },
        },
        {
          path: 'create',
          name: 'boxinspection.quality_categories_defects',
          component: DefectGroupsCreateEdit,
          meta: {
            prefix_permission: 'quality_defectgroups',
          },
        },
        {
          path: 'edit',
          name: 'boxinspection.quality_categories_defects',
          component: DefectGroupsCreateEdit,
          meta: {
            prefix_permission: 'quality_defectgroups',
          },
        },
      ],
    },
    {
      path: 'boxinspections',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'boxinspection.box_inspections',
          component: BoxInspection,
          meta: {
            prefix_permission: 'quality_boxinspections',
          },
        },
        {
          path: 'create',
          name: 'boxinspection.box_inspections',
          component: EditCreate,
          meta: {
            prefix_permission: 'quality_boxinspections',
          },
        },
        {
          path: 'edit',
          name: 'boxinspection.box_inspections',
          component: EditCreate,
          props: true,
          meta: {
            prefix_permission: 'quality_boxinspections',
          },
        },
      ],
    },
    {
      path: 'pcmsreport',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'boxinspection.pcms_report',
          component: PCMSReport,
          meta: {
            prefix_permission: 'quality_pcmsreport',
          },
        },
      ],
    },

  ],
};

export default QualityRoutes;
